import { Button } from "../Button/index.js";
import React from "react";
import { IconClose } from "@synthesis/shared-icons";
import { jsx } from "react/jsx-runtime";
import { useWatch } from "react-hook-form";
//#region src/Input/ClearButton.tsx
const ClearButton = React.memo(({ onReset, control, name }) => {
	const value = useWatch({
		control,
		name
	});
	if (!(typeof value === "string" ? value.length > 0 : Boolean(value))) return null;
	return /* @__PURE__ */ jsx(Button, {
		onClick: onReset,
		size: "xs",
		theme: "text",
		customClassNames: ["size-5 focus:outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-system-info-70 focus-visible:outline-offset-1"],
		children: /* @__PURE__ */ jsx(IconClose, { className: "size-4" })
	});
});
ClearButton.displayName = "ClearButton";
//#endregion
export { ClearButton };

//# sourceMappingURL=ClearButton.js.map